import * as types from '../constants/actions/loan-account';
import { showMessageBar, showLoading, hideLoading } from '../actions/app';
import { 
  link as requestLinkLoanAccount, 
  notifyLender, 
  all as requestFetchLoanAccounts,
  requestDeleteLoanAccount } from '../api/loan-account';
import LoanAccountService from '../services/loan-account';
import { findById } from '../helpers/app';
import { dateWithFormatOrNa } from '../helpers/formatters';

const loanAccountService = new LoanAccountService();

/**
 * Link a loan account.
 * 
 * @param payload
 */
export function linkLoanAccount(payload) {
  return function (dispatch) {
    let newData = {
      ...payload, 
      dob: payload.dob ? dateWithFormatOrNa(payload.dob) : '',
      ssn: payload.ssn ? payload.ssn : ''
    };

    return requestLinkLoanAccount(newData)
      .then(function(response) {
        let data = response.data;

        if (data.status === 1 && data.statusCode === 200) {
          dispatch(showMessageBar({status: 'success', text: data.message}));
        } else {
          dispatch(showMessageBar({status: 'error', text: data.message}));
        }
        
        return response;
      })
      .catch((error) => {
        return Promise.reject(error);
      })
  }
}

/**
 * Notify to lender than linking loan account has failed.
 * 
 * @param {*} loanAccount 
 */
export function notifyLoanAccount(loanAccount) {
  return {
    type: types.NOTIFY_LOAN_ACCOUNT_LINKING,
    payload: notifyLender(loanAccount)
  }
}

/**
 * Fetch all loan accounts.
 */
export function fetchLoanAccounts() {
  return function (dispatch) {
    return requestFetchLoanAccounts()
      .then(function(response) {
        let data = response.data;
        
        if (data.status === 1 && data.statusCode === 200) {
          let loanAccounts = data.result.loans;

          if (loanAccounts.length > 0) {
            let selectedLoanAccount = parseInt(loanAccountService.getSelectedId(), 10);
            selectedLoanAccount =  findById(selectedLoanAccount, loanAccounts);

            // Select the first loan account if none is selected yet or the selected was removed.
            if (!selectedLoanAccount) {
              selectedLoanAccount = loanAccounts[0];
              loanAccountService.setSelectedLoanAccount(selectedLoanAccount.id);
            }

            dispatch(setLoanAccounts(loanAccounts));
            dispatch(setSelectedLoanAccount(selectedLoanAccount.id));
          }
        } else if (data.status === 1 && data.statusCode === 201) {
          dispatch(setLoanAccounts([]));
        }

        return response;
      })
      .catch((error) => {
        return Promise.reject(error);
      })
  }
}

export function setLoanAccounts(payload) {
  return {
    type: types.SET_LOAN_ACCOUNTS,
    payload
  }
}

export function setSelectedLoanAccount(payload) {
  loanAccountService.setSelectedLoanAccount(payload);
  
  return {
    type: types.SET_SELECTED_LOAN_ACCOUNT,
    payload
  }
}

export function deleteLoanAccount(id) {
  return function (dispatch) {
    dispatch(showLoading());

    return requestDeleteLoanAccount(id)
      .then(function(response) {
        let data = response.data;
        dispatch(hideLoading());

        if (data.status === 1 && data.statusCode === 200) {
          dispatch(showMessageBar({
            status: 'success',
            text: data.message
          }));
        }

        return response;
      })
      .catch(() => {
        dispatch(hideLoading());
      });
  }
}



// WEBPACK FOOTER //
// ./src/actions/loan-account.js